import React  from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import CreateReceiptSubheader from '../../../components/LocalReceipts/CreateReceipts/CreateReceiptSubheader'
import CreateReceiptSidebar from '../../../components/LocalReceipts/CreateReceipts/CreateReceiptSidebar'
import CreateReceiptContentArea from '../../../components/LocalReceipts/CreateReceipts/CreateReceiptContentArea'
import LocalReceiptDataProvider from '../../../stores/LocalReceiptDataProvider'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`

const CreateGoodsReceiptPage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()
  const dashboardLoaded = useObserver(() => !!uiStore.dashboard)

  return useObserver(() => (
    <LocalReceiptDataProvider>
      <StyledGoodReceiptsContainer>
        {!(uiStore.isLocalStorageAdmin) ? (
          <>
            <StyledContentArea>
            {dashboardLoaded
                  ? <Alert variant="danger">{t('goodsReceiptPage:addReceiptAlert')}</Alert>
                  : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                }
            </StyledContentArea>
          </>
        ) : (
          <>
            <CreateReceiptSubheader />
            <FlexWrapper>
              <StyledContentArea>
                <CreateReceiptContentArea />
              </StyledContentArea>
              <TestSidebarRight>
                <CreateReceiptSidebar />
              </TestSidebarRight>
            </FlexWrapper>
            <BigFooter />
          </>
        )}
      </StyledGoodReceiptsContainer>
    </LocalReceiptDataProvider>

  ))
}

export default CreateGoodsReceiptPage


